import React from 'react';

import { Box } from '@material-ui/core';

import useStyles from './styles';

type Props = {
  percent: number;
};

const Chart: React.FC<Props> = ({ percent }) => {
  const classes = useStyles();

  return (
    <Box className={classes.chart}>
      <svg viewBox='0 0 36 36' className={classes.stroke}>
        <path
          className={classes.circleBg}
          d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
        />
        <path
          className={classes.circle}
          strokeDasharray={`${percent}, 100`}
          d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
        />
      </svg>
    </Box>
  );
};

export default Chart;
